<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/machine/list" color="blue">取消回上一頁</v-btn>
    </div>

    <v-form @submit.prevent="submit()" v-model="valid">
      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">機器基本資料</p>

          <v-text-field v-model="form.serial_number" :rules="[formRules.required]" label="機器序號" outlined></v-text-field>
          <v-text-field v-model="form.name" :rules="[formRules.required]" label="機器名稱" outlined></v-text-field>
          <div class="row">
            <div class="col-6 col-md-3 py-0">
              <v-select
                v-model="city"
                @change="cityDistrictChange"
                :items="Object.keys(city_districts)"
                :rules="[formRules.required]"
                placeholder="縣市"
                outlined
              ></v-select>
            </div>
            <div class="col-6 col-md-3 py-0">
              <v-select
                v-model="form.city_district_id"
                :readonly="!city"
                :items="city_districts[city]"
                item-text="district"
                item-value="city_district_id"
                :rules="[formRules.required]"
                placeholder="鄉鎮市區"
                outlined
              ></v-select>
            </div>
          </div>
          <v-text-field v-model="form.address" :rules="[formRules.required]" label="地址" outlined></v-text-field>
          <v-text-field v-model="form.version" :rules="[formRules.required]" label="版本" outlined></v-text-field>
        </v-card-text>
      </v-card>

      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">優惠方案</p>

          <template v-for="deal in deals">
            <v-checkbox
              v-model="form.deal_ids"
              :value="deal.deal_id"
              :rules="[formRules.checkbox]"
              :label="deal.display_name"
              color="teal"
            ></v-checkbox>
          </template>
        </v-card-text>
      </v-card>

      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">支付方式</p>

          <template v-for="payment_method in payment_methods">
            <v-checkbox
              v-model="form.payment_method_ids"
              :value="payment_method.payment_method_id"
              :rules="[formRules.checkbox]"
              :label="payment_method.display_name"
              color="teal"
            ></v-checkbox>
          </template>
        </v-card-text>
      </v-card>

      <div class="text-center mb-6">
        <v-btn to="/machine/list" color="blue" class="mr-3">取消回上一頁</v-btn>
        <v-btn type="submit" :disabled="!valid" color="orange">確認新增</v-btn>
      </div>
    </v-form>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import systemApi from "@/api/system";
import machineApi from "@/api/machine";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      city_districts: {},
      deals: [],
      payment_methods: [],

      valid: false,

      city: "",
      form: {
        serial_number: "",
        name: "",
        city_district_id: "",
        address: "",
        version: "",
        deal_ids: [],
        payment_method_ids: []
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    cityDistrictChange() {
      this.form.city_district_id = 0;
    },

    submit() {
      machineApi
        .create(this.form)
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });
          } else {
            this.$router.push("/machine/list");
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    systemApi
      .getCityDistricts()
      .then(res => {
        this.city_districts = res.city_districts;
      })
      .catch(err => {});

    machineApi
      .getOptions()
      .then(res => {
        this.deals = res.deals;
        this.payment_methods = res.payment_methods;
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
